import type { ComponentStyleConfig } from '@chakra-ui/theme';

const Shimmer: ComponentStyleConfig = {
  parts: ['BarChartContainer'],
  baseStyle: {
    BarChartContainer: {
      width: 'full',
      justifyContent: 'space-between',
      alignItems: 'flex-end',
    },
    AreaChartContainer: {
      width: 'full',
      alignItems: 'baseline',
      overflow: 'hidden',
    },
  },
};

export default Shimmer;
